import { render, staticRenderFns } from "./TaxratesetupGrid.vue?vue&type=template&id=671bf148"
import script from "./TaxratesetupGrid.vue?vue&type=script&lang=js"
export * from "./TaxratesetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports